import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { SectionContext } from '../../../../Types';
import Experience from '../Experience';
import { filteredExperiences } from '../Experience/Filtering';
import { sortExperiences } from '../SortTemplate/Types';
import Store from '../Store';
import { ExperiencesResource, Toggle } from '../Types';
import { useFilterStoreContext } from './FilterStores';
import Heading from './Heading';
import { LearningCollectionEditFormResource } from '../../../../Edit/Store/Types';
import { emptyFragment } from '../../../../../../../EmptyFragment';

interface Props {
  store: Store;
  experiences: ExperiencesResource;
  learningDesignName: AlreadyTranslatedText;
  learningCollectionStore: LearningCollectionEditStore;
  context: SectionContext;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

const ModalBody: React.FC<Props> = ({
  store,
  experiences,
  learningDesignName,
  learningCollectionStore,
  context,
  learningCollectionEditFormResource,
}) => {
  const [toggle, setToggle] = useState<Toggle>('show-licensed');

  const filtered = useFilterStoreContext().map(
    ({
      productTypeFilterStore,
      durationFilterStore,
      competencyFilterStore,
      schoolPartnerFilterStore,
      languageFilterStore,
    }) =>
      filteredExperiences(
        experiences,
        productTypeFilterStore,
        competencyFilterStore,
        durationFilterStore,
        schoolPartnerFilterStore,
        languageFilterStore,
        toggle,
      ),
  );

  return (
    <div className="mt-12 mb-4">
      {filtered
        .map((filteredExperiences) => (
          <>
            <Heading
              store={store}
              learningDesignName={learningDesignName}
              filteredExperiences={filteredExperiences}
              experiences={experiences}
              learningCollectionStore={learningCollectionStore}
              context={context}
              setToggle={setToggle}
              toggle={toggle}
            />
            <div className="max-h-[60vh] overflow-y-auto px-11">
              <>
                {useFilterStoreContext()
                  .map(({ sortStore }) => (
                    <>
                      {sortExperiences(sortStore.state.sortOption, filteredExperiences).map(
                        (experience) => (
                          <Experience
                            store={store}
                            resource={experience}
                            key={experience.payload.id}
                            context={context}
                            learningCollectionStore={learningCollectionStore}
                            learningDesignName={learningDesignName}
                            sectionContext={context}
                            learningCollectionEditFormResource={learningCollectionEditFormResource}
                          />
                        ),
                      )}
                    </>
                  ))
                  .getOrElse(emptyFragment)}
              </>
            </div>
          </>
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
};

export default observer(ModalBody);
